import { Chip as MuiChip } from '@mui/material'
import { RxCross2 } from 'react-icons/rx'
import { tss } from 'tss-react'
import { ChipProps } from '../types'
import { getChipBasePrimitives, getChipColorPrimitives } from './primitives'

/**
 * Renders a chip with a solid background
 */
export function SolidChip({
  color,
  isRounded = false,
  className,
  noPadding = false,
  ...rest
}: Omit<ChipProps, 'variant'>) {
  const { cx, classes } = useStyles({ color, isRounded, noPadding })

  return (
    <MuiChip
      className={cx(classes.chip, className)}
      deleteIcon={<RxCross2 className="min-h-4 min-w-4" size="16px" />}
      {...rest}
    />
  )
}

const useStyles = tss
  .withParams<Omit<ChipProps, 'variant'>>()
  .create(({ color, isRounded, noPadding }) => {
    const chipBasePrimitives = getChipBasePrimitives('solid', color, isRounded, noPadding)
    const colorPrimitives = getChipColorPrimitives('solid', color)

    return {
      chip: {
        ...colorPrimitives,
        ...chipBasePrimitives,
      },
    }
  })
